if (!customElements.get('tab-group')) {
  customElements.define(
    'tab-group',
    class TabGroup extends HTMLElement {
      constructor() {
        super();

        this.tabBtnList = this.querySelectorAll('.tab-group__tab-button');
        this.tabContentList = this.querySelectorAll('.tab-group__content');

        this.tabBtnList.forEach((btn) =>
          btn.addEventListener('click', this.setCurrentTab.bind(this, btn.dataset.tabTrigger))
        );

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (!this.querySelector(`[data-tab-target='${e.detail.blockId}']`)) return;
            this.setCurrentTab(e.detail.blockId);
          });
        }
      }

      setCurrentTab(blockId) {
        this.tabBtnList.forEach((el) => {
          if (el.dataset.tabTrigger === blockId) {
            el.classList.add('tab-group__tab-button--active');
          } else {
            el.classList.remove('tab-group__tab-button--active');
          }
        });

        this.tabContentList.forEach((el) => {
          if (el.dataset.tabTarget === blockId) {
            el.classList.add('tab-group__content--active');
            el.ariaHidden = 'false';
          } else {
            el.classList.remove('tab-group__content--active');
            el.ariaHidden = 'true';
          }
        });
      }
    }
  );
}
